import React, { useState } from 'react';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import '../ConnectionStatus/ConnectionStatus.css';

function AddContactModal({ isOpen, onClose, onAddContact }) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');

  if (!isOpen) return null;

  const handleSubmit = () => {
    if (!name.trim() || !phone.trim()) {
      toastr.info(' ', 'Имя и номер телефона не могут быть пустыми.');
      return;
    }
    onAddContact(name, phone);
    setName('');
    setPhone('');
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-content" style={{ maxWidth: '400px' }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h4>Добавить новый контакт</h4>
        </div>
        <div className="modal-body">
          <input
            type="text"
            placeholder="Имя контакта"
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={{ width: '100%', padding: '10px', marginBottom: '10px', boxSizing: 'border-box' }}
          />
          <input
            type="text"
            placeholder="Номер телефона"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            style={{ width: '100%', padding: '10px', marginBottom: '15px', boxSizing: 'border-box' }}
          />
        </div>
        <div className="modal-actions" style={{ justifyContent: 'flex-end' }}>
          <button onClick={onClose}>Отмена</button>
          <button onClick={handleSubmit}>Добавить</button>
        </div>
      </div>
    </div>
  );
}

export default AddContactModal;
